import { NavLink, useLocation } from "react-router-dom";
import { Home, Search, MessageSquare, LayoutDashboard, User, Ticket } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { useEffect, useState } from "react";
import api from "../lib/api";

const items = [
  { to: "/", label: "Accueil", icon: Home, testid: "bnav-home", exact: true },
  { to: "/events", label: "Billets", icon: Ticket, testid: "bnav-events" },
  { to: "/explore", label: "Explorer", icon: Search, testid: "bnav-explore" },
  { to: "/messages", label: "Messages", icon: MessageSquare, testid: "bnav-messages", auth: true },
];

export default function BottomNav() {
  const { user } = useAuth();
  const location = useLocation();
  const [unread, setUnread] = useState(0);

  // Hide on auth screens for cleaner mobile UX
  const hide = ["/login", "/register"].includes(location.pathname);

  useEffect(() => {
    if (!user) { setUnread(0); return; }
    let stop = false;
    const fetchUnread = async () => {
      try {
        const { data } = await api.get("/conversations/mine");
        if (stop) return;
        const total = (data.conversations || []).reduce((s, c) => s + (c.unread_count || 0), 0);
        setUnread(total);
      } catch { /* ignore */ }
    };
    fetchUnread();
    const t = setInterval(fetchUnread, 15000);
    return () => { stop = true; clearInterval(t); };
  }, [user]);

  if (hide) return null;

  const visible = items.filter((i) => !i.auth || user);
  const lastItem = user
    ? { to: "/dashboard", label: "Profil", icon: User, testid: "bnav-profile" }
    : { to: "/login", label: "Connexion", icon: User, testid: "bnav-login" };

  const list = [...visible.slice(0, 4)];
  if (!user) list.push(lastItem);

  return (
    <>
      {/* Spacer so content isn't hidden behind nav */}
      <div className="h-16 md:hidden" aria-hidden />
      <nav
        data-testid="mobile-bottom-nav"
        className="md:hidden fixed bottom-0 inset-x-0 z-40 backdrop-blur-xl bg-white/90 border-t border-border"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <ul className="grid grid-cols-4">
          {list.map(({ to, label, icon: Icon, testid, exact }) => (
            <li key={to}>
              <NavLink
                to={to}
                end={exact}
                data-testid={testid}
                className={({ isActive }) =>
                  `relative flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] font-mono uppercase tracking-wider transition-colors ${
                    isActive ? "text-[hsl(var(--primary))]" : "text-muted-foreground"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon className={`w-5 h-5 ${isActive ? "scale-110" : ""} transition-transform`} />
                    <span>{label}</span>
                    {testid === "bnav-messages" && unread > 0 && (
                      <span data-testid="bnav-unread-badge" className="absolute top-1.5 right-[28%] min-w-[16px] h-[16px] px-1 bg-[hsl(var(--primary))] text-white text-[9px] font-bold rounded-full flex items-center justify-center">
                        {unread > 9 ? "9+" : unread}
                      </span>
                    )}
                    {isActive && <span className="absolute top-0 inset-x-6 h-[2px] bg-[hsl(var(--primary))]" />}
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}
